import axios from "axios";
import { base_url } from "../config";

export const fetchData = async () => {
  const accessToken = localStorage.getItem("@user");

  try {
    const response = await axios.get(`${base_url}/users/questions`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};
